import {connect} from 'react-redux';
import Form_4 from './Form_4';
import {submitStep} from '../../actions/steps/submitStep';
import {uploadFile} from '../../actions/files/uploadFile';
import {getShumaStepStatus} from '../../actions/steps/getShumaStepStatus';
import {showGlobalErrorMessage} from 'common/actions/globalErrorMessage/showGlobalErrorMessage';
import {getStepData} from '../../actions/steps/getStepData';
import {getFileList} from '../../actions/files/getFileList';

const mapStateToProps = ({
                           stepData: {stepData},
                           step11FileList: {list: filesListData}
                         }) => ({
  stepData,
  filesListData
});

export default connect(
  mapStateToProps,
  {
    submitStep,
    uploadFile,
    getShumaStepStatus,
    showGlobalErrorMessage,
    getStepData,
    getFileList
  }
)(Form_4);
